<mat-card>
  <mat-card-header>
    <mat-card-title>
      <mat-checkbox
        (change)="onChange($event.checked)"
        [disabled]="valueDisabled()"
        *ngIf="isUserEntity()"
      >
      </mat-checkbox>
      SKU {{ data.skuCode }}
      <span [ngClass]="valueColor(data.status)">{{ data.status }}</span>
    </mat-card-title>
    <mat-card-subtitle>
      Ubicación <span>{{ data.location }}</span>
    </mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <div>
      <p>
        <b>{{ data.description }}</b>
      </p>
      <p>Cantidad total: {{ data.quantity }}</p>
      <p>Entregado: {{ data.deliveredQuantity }}</p>
      <p>Pendiente: {{ data.pendingQuantity }}</p>
      <p>Cancelado: {{ data.canceledQuantity }}</p>
    </div>
  </mat-card-content>
</mat-card>
